import {
    Typography,
    styled,
} from "@mui/material"

export const Title = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}))

export const ContentWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(4),
}))